(function($){
    var $fileUploadSentMail = {
        $files: [],
        $settings: {
            deleteEvent: true,
            errorCode: {
                '-701': 'MEMORY_ERROR',
                '-702': '@name@ IMAGE_DIMENSIONS_ERROR',
                '-700': '@name@ IMAGE_FORMAT_ERROR',
                '-602': '@name@ FILE_DUPLICATE_ERRO',
                '-601': '@name@ FILE_EXTENSION_ERROR',
                '-600': '@name@ FILE_SIZE_ERROR',
                '-500': 'INIT_ERROR',
                '-400': 'SECURITY_ERROR',
                '-300': 'IO_ERROR',
                '-200': 'HTTP_ERROR',
                '-100': 'GENERIC_ERROR',
            },
        },
        plupLoadInit: function ($) {
            return new plupload.Uploader({
                browse_button: 'file-upload',
                drop_element: 'body',
                url: app_start_local_data.upload_file,
                max_file_size: '1mb',
                filters: [
                    {title: "Image files", extensions: "jpg,gif,png,pdf,txt,xls,xlsx,doc,docx,jpge,ppt,pptx"},
                    {title: "Zip files", extensions: "zip"}
                ]
            });
        },

        fileAddedMarkup: function ($, $file, $this) {
            var html = false;
            var $div = $('<div>', {class: 'single-file'});
            var $fileNameNode = $('<span>', {class: 'file-name'});
            var $fileSizeNode = $('<span>', {class: 'file-size'});
            var $close = $('<a>', {class: 'file-close'});
            var $fileId = $file.id;
            var $fileName = $file.name;
            var $fileSize = $file.size;
            $close.attr('data-file-id', $fileId).text('x');
            $fileNameNode.text($fileName);
            $fileSizeNode.text(formatSizeUnits($fileSize));
            $div.attr('id', $fileId);
            $close.appendTo($div);
            $fileNameNode.appendTo($div);
            $fileSizeNode.appendTo($div);
            html = $div;
            return html;
        },

        onPlupAddfile: function ($, $plupUploadHandler, $this) {
            $plupUploadHandler.bind('FilesAdded', function (up, files) {
                var $uploadContainer = $('.upload-inner');
                var $uploadFilesContainer = $uploadContainer.find('.drag-container');
                var $dragInnerHtml = $uploadFilesContainer.html();
                plupload.each(files, function (file) {
                    var $markUp = $this.fileAddedMarkup($, file, $this, $plupUploadHandler);
                    $uploadFilesContainer.append($markUp);
                });
                $plupUploadHandler.start();
                if ($this.$settings.deleteEvent) {
                    $this.fileDelete($, $plupUploadHandler, $this);
                    $this.$settings.deleteEvent = false;
                }
            });
        },

        fileUploadEvent: function ($, $plupUploadHandler, $this) {
            $plupUploadHandler.bind('FileUploaded', function (uploader, file, response) {
                $fileDiv = $('#' + file.id);
                $fileName = response.response;
                $fileDiv.find('a').attr('data-file-name', $fileName);
                $this.$files.push($fileName);
                $fileDiv.animate({opacity: 1});
            });

            $plupUploadHandler.bind('UploadComplete', function (uploader, file, response) {
                var $inqury_submit = $('.inquiry-submit');
                var $singleFiles = $('.single-file');
                $inqury_submit.find('input').removeAttr('disabled');
                $singleFiles.removeClass('appstar_disable');
            });

            $plupUploadHandler.bind('BeforeUpload', function (upload, file) {
                var $inqury_submit = $('.inquiry-submit');
                var $singleFiles = $('.single-file');
                $inqury_submit.find('input').attr('disabled', "disabled");
                $singleFiles.addClass('appstar_disable');
            });
        },

        fileDelete: function ($, $plupUploadHandler, $this) {
            $(document).on('click', '.file-close', function (e) {
                e.preventDefault();
                var $inqury_submit = $('.inquiry-submit');
                var $singleFiles = $('.single-file');
                $inqury_submit.find('input').attr('disabled', "disabled");
                $singleFiles.addClass('appstar_disable');
                $fileId = $(this).attr('data-file-id');
                $fileName = $(this).attr('data-file-name');
                $plupUploadHandler.files.forEach(function (index) {
                    if (index.id == $fileId) {
                        $plupUploadHandler.removeFile(index);
                    }
                });
                $.post(app_start_local_data.ajaxurl, {
                    'action': 'delete-uploaded-file',
                    'data': {
                        'name': $fileName

                    }
                }, function (response) {
                    if ($this.$files.indexOf($fileName) != -1) {
                        $this.$files.splice($this.$files.indexOf($fileName), 1);
                    }
                    $inqury_submit.find('input').removeAttr('disabled');
                    $singleFiles.removeClass('appstar_disable');
                });
                $parent = $('#' + $fileId);
                $parent.remove();
            });
        },

        onPlupError: function ($, $plupUploadHandler, $this) {
            $plupUploadHandler.bind('Error', function (up, err) {
                var error = $this.$settings.errorCode[err.code];
                if (error.indexOf('@name@') !== -1) {
                    error = error.replace('@name@', err.file.name);
                }
                $this.errorMessage($, error);
            }, [], 0);
        },

        errorMessage: function ($, $message) {
            var errorWrapper = $('.file-upload-error'),
                newError = $('<p>', {class: 'upload-error'});
            newError.text($message);
            newError.appendTo(errorWrapper);
            setTimeout(function () {
                newError.fadeOut(1000, function () {
                    $(this).remove();
                });
            }, 10000);
        },

        formSubmit: function ($, $this, $plupUploadHandler) {
            var $form = $('.inquiry-js form');
            $form.on('submit', function (e) {
                e.preventDefault();
                if ($(this).valid() ) {
                    var $formData = $(this).serializeArray(), $formDataObjects = {};
                    var captchaData = { value: -1 }; 
                    
                    $formData.forEach(function (index) {
                        if(index.name != 'g-recaptcha-response') {
                            $formDataObjects[index.name] = index.value;
                        }else{
                            captchaData = index;
                        }
                    });
                    if(captchaData != -1){
                        const data = {
                            'action': 'check_recaptcha',
                            'captcha': captchaData.value,
                            'nonce': $('#g-recaptcha').data('nonce')
                        };
                        $.ajax({
                            type: 'POST',
                            url: app_start_local_data.ajaxurl,
                            data: data,
                            success: function(response){
                                if (response == 'true') {
                                    $('.g-recaptcha').closest(".inquiry-form-group").find(".invalid-feedback").hide();
                                    $this.sendMailRequest($, $this, $plupUploadHandler, $formDataObjects);
                                } 
                                else {
                                    $('.g-recaptcha').closest(".inquiry-form-group").find(".invalid-feedback").show().css('color', '#ff4b4b');
                                }
                            },
                            async:false
                        });
                    }else{
                        $this.sendMailRequest($, $this, $plupUploadHandler, $formDataObjects);
                    }
                }

            });
        },
        sendMailRequest: function ($, $this, $plupUploadHandler, $details) {
            var $action = "send-mail-request";
            var $data = {};
            var $form = $('.inquiry-js form');
            $form.addClass('loading');
            $data.action = $action;
            $data.details = $details;
            $data.files = $this.$files;
            $.post(app_start_local_data.ajaxurl, $data, function (response) {
                if (response.indexOf('true') > -1) {
                    window.location = app_start_local_data.tahkyouPage;
                } else {
                    $this.errorMessage($, 'case1:何かが間違っています。後でもう一度試してください。');
                }
                $form.removeClass('loading');
            }).always(function () {
                $form[0].reset();
            }).fail(function () {
                $this.errorMessage($, 'case2:何かが間違っています。後でもう一度試してください。');
                $form.removeClass('loading');
            });
        },
        inqueryHidden: function ($) {
            $('.request-details a').on('click', function (e) {
                e.preventDefault();
                $('.check-list').toggleClass('active-check-list');
            });
        },
        plupMain: function ($) {
            var $plupUploadHandler = this.plupLoadInit($);
            $plupUploadHandler.init();
            this.onPlupAddfile($, $plupUploadHandler, this);
            this.onPlupError($, $plupUploadHandler, this);
            this.fileUploadEvent($, $plupUploadHandler, this);
            this.formSubmit($, this, $plupUploadHandler);
            this.inqueryHidden($);
            setTimeout(function () {
                window.location.href = window.location.href;
            }, (1000 * 60 * 55));
        }
    };
    $fileUploadSentMail.plupMain($);
}(jQuery));
function formatSizeUnits(bytes) {
    if (bytes >= 1073741824) {
        bytes = (bytes / 1073741824).toFixed(2) + ' GB';
    }
    else if (bytes >= 1048576) {
        bytes = (bytes / 1048576).toFixed(2) + ' MB';
    }
    else if (bytes >= 1024) {
        bytes = (bytes / 1024).toFixed(2) + ' KB';
    }
    else if (bytes > 1) {
        bytes = bytes + ' bytes';
    }
    else if (bytes == 1) {
        bytes = bytes + ' byte';
    }
    else {
        bytes = '0 byte';
    }
    return bytes;
}